import { render, staticRenderFns } from "./UserLine.vue?vue&type=template&id=99b9e4c2&scoped=true"
import script from "./UserLine.vue?vue&type=script&lang=js"
export * from "./UserLine.vue?vue&type=script&lang=js"
import style0 from "./UserLine.vue?vue&type=style&index=0&id=99b9e4c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b9e4c2",
  null
  
)

/* custom blocks */
import block0 from "./UserLine.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports